import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { loadMultipleAppTranslations } from "@/i18n/translationLoader";

// Generic guard that can be used for any app
export const createTranslationGuard = (appNames: string | string[]) => {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  return async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    try {
      const apps = Array.isArray(appNames) ? appNames : [appNames];
      console.log(`Loading translations for apps: ${apps.join(", ")}`);

      await loadMultipleAppTranslations(apps);
      next();
    } catch (error) {
      console.error("Failed to load translations:", error);
      // Continue anyway - components can handle missing translations
      next();
    }
  };
};

// Specific guards for common apps
export const adminConsoleTranslationGuard = createTranslationGuard([
  "admin-console",
  "shared",
]);
export const coreAppOnboardingTranslationGuard = createTranslationGuard([
  "core-app-onboarding",
  "shared",
]);
export const creditLineTranslationGuard = createTranslationGuard([
  "credit-line",
  "shared",
]);
export const dashboardTranslationGuard = createTranslationGuard([
  "dashboard",
  "shared",
]);
export const loginTranslationGuard = createTranslationGuard([
  "login",
  "shared",
]);
export const merchant3TranslationGuard = createTranslationGuard([
  "merchant3",
  "shared",
]);
export const personRegistrationTranslationGuard = createTranslationGuard([
  "person-registration",
  "shared",
]);
